<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    <el-table :data="list" v-loading="listLoading" style="width: 100%">
      <el-table-column type="index" label="序号" width="80"></el-table-column>
      <el-table-column prop="Name" label="项目名称"></el-table-column>
      <el-table-column prop="MatchName" label="比赛名称"></el-table-column>

      <el-table-column prop="Price" label="价格"></el-table-column>
      <el-table-column
        prop="Desc"
        label="简介"
        width="360"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="封面">
        <template slot-scope="scope">
          <el-image
            style="width: 50px; height: 50px"
            :src="scope.row.Picture"
            fit="cover"
            :preview-src-list="[scope.row.Picture]"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="260">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button plain size="mini" @click="handleLaunch(scope.row)">
            {{ scope.row.IsLaunch ? "下架" : "上架" }}
          </el-button>
          <el-button type="danger" size="mini" @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="mt16">
      <div class="mt16">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="page.currentPage"
          :page-sizes="[10, 20, 30, 40, 50, 100]"
          :page-size="page.pageSize"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 新增 -->
    <el-dialog title="新增" :visible.sync="addFormVisible">
      <el-form
        :model="addForm"
        label-width="120px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item label="项目名称" prop="Name">
          <el-input
            v-model="addForm.Name"
            placeholder="请输入项目名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="比赛" prop="MatchName">
          <el-select v-model="addForm.MatchName" @change="chooseMatch">
            <el-option
              v-for="item in matchList"
              :key="item.Id"
              :label="item.Name"
              :value="{
                Name: item.Name,
                Id: item.Id,
              }"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="简介" prop="Desc">
          <el-input type="textarea" :row="3" v-model="addForm.Desc"></el-input>
        </el-form-item>
        <el-form-item label="封面" prop="Picture">
          <Upload
            @upload="handleUpload"
            @delete="handleDelete"
            type="match"
          ></Upload>
        </el-form-item>
        <el-form-item label="价格" prop="Price">
          <el-input-number v-model="addForm.Price"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click="addSubmit">确定</el-button>
      </span>
    </el-dialog>
    <!-- 编辑 -->
    <el-dialog title="编辑" :visible.sync="editFormVisible">
      <el-form
        :model="editForm"
        label-width="120px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-form-item label="项目名称" prop="Name">
          <el-input
            v-model="editForm.Name"
            placeholder="请输入项目名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="比赛" prop="MatchName">
          <el-select v-model="editForm.MatchName" @change="chooseMatch">
            <el-option
              v-for="item in matchList"
              :key="item.Id"
              :label="item.Name"
              :value="{
                Name: item.Name,
                Id: item.Id,
              }"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="简介" prop="Desc">
          <el-input type="textarea" :row="3" v-model="editForm.Desc"></el-input>
        </el-form-item>
        <el-form-item label="封面" prop="Picture">
          <Upload
            @upload="handleEditUpload"
            @delete="handleEditDelete"
            :fileUrl="editForm.Picture"
            type="match"
          ></Upload>
        </el-form-item>
        <el-form-item label="价格" prop="Price">
          <el-input-number v-model="editForm.Price"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click="editSubmit">确定</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import {
  productList,
  matchListAll,
  addProduct,
  updateProduct,
  deleteProduct,
  updateProductIsLaunch,
} from "@/api/match/match";
import Upload from "../../components/Upload";
export default {
  components: { Toolbar, Upload },
  data() {
    return {
      buttonList: [],
      page: {
        currentPage: 1,
        pageSize: 10,
      },
      list: [],
      listLoading: false,
      total: 0,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {},
      //新增界面数据
      addForm: {},
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {},
      //编辑界面数据
      editForm: {},
      matchList: [],
    };
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.getList();
    this.getMatch();
  },
  methods: {
    handleUpload(e) {
      this.addForm.Picture = e;
    },
    handleDelete() {
      this.addForm.Picture = "";
    },
    handleEditUpload(e) {
      this.editForm.Picture = e;
    },
    handleEditDelete() {
      this.editForm.Picture = "";
    },
    editSubmit() {
      this.editLoading = true;
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editLoading = true;
          updateProduct(this.editForm).then((res) => {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.$refs["editForm"].resetFields();
            this.editFormVisible = false;
            this.initPage();
            this.getList();
          });
        }
      });
    },
    addSubmit() {
      this.addLoading = true;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;
          addProduct(this.addForm).then((res) => {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.$refs["addForm"].resetFields();
            this.addFormVisible = false;
            this.initPage();
            this.getList();
          });
        }
      });
    },
    chooseMatch(e) {
      this.addForm.MatchId = e.Id;
      this.addForm.MatchName = e.Name;
    },
    handleAdd() {
      this.addForm = {};
      this.addFormVisible = true;
    },
    getMatch() {
      matchListAll().then((res) => {
        this.matchList = res.data.response;
      });
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getList();
    },
    initPage() {
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.filters = {
        name: "",
      };
    },
    handleEdit(row) {
      this.editForm = Object.assign({}, row);
      this.editFormVisible = true;
    },
    handleDelete(row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      }).then(() => {
        deleteProduct({ Id: row.Id }).then((res) => {
          if (res.data.success) {
            this.initPage();
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getList();
          }
        });
      });
    },
    handleLaunch(row) {
      const actionText = row.IsLaunch ? "下架" : "上架";
      this.$confirm(`确认${actionText}该赛事项目吗?`, "提示", {
        type: "warning",
      })
        .then(() => {
          const params = {
            Id: row.Id,
            IsLaunch: !row.IsLaunch,
          };
          updateProductIsLaunch(params).then((res) => {
            if (res.data && res.data.success) {
              this.$message({
                message: res.data.msg || `${actionText}成功`,
                type: "success",
              });
              this.getList();
            } else {
              this.$message({
                message: (res.data && res.data.msg) || `${actionText}失败`,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    getList() {
      this.listLoading = true;
      let para = {
        page: this.page.currentPage,
        intPageSize: this.page.pageSize,
      };
      productList(para)
        .then((res) => {
          this.total = res.data.response.dataCount;
          this.list = res.data.response.data;
          this.listLoading = false;
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
  },
};
</script>
